import { useDesignMaxTheme } from "@/packages";
import { useBookingRecoilValue } from "@/shared/client";
import { AMENITY_GROUP } from "@/shared/client/constants/amenityGroup";
import { FONT } from "@/styles";
import { Box, Button, Center, Flex, Image, Text } from "@chakra-ui/react";
import { type RoomListType } from "../../../otherRoomPreview/otherRoomPreview.type";

export const RoomDesc = ({ room }: { room: RoomListType }) => {
    const { MEDIAS } = useDesignMaxTheme();
    const bookingURL = useBookingRecoilValue();

    const onLink = (url: string) => {
        if (bookingURL.includes("http")) {
            window.open(url, "_blank");
        }
        if (!bookingURL.includes("http")) {
            window.open(`https://${url}`, "_blank");
        }
    };
    const { isMobile } = MEDIAS();

    const activeAmenities = AMENITY_GROUP.filter(
        ({ name }) => room.amenity_icon[name as keyof typeof room.amenity_icon],
    );
    return (
        <Flex
            maxW="896px"
            w="100%"
            flexDir="column"
            p={isMobile ? "24PX 16PX 0 16PX" : "120px 80px 0 80px"}
            gap={isMobile ? "16px" : "32px"}
        >
            <Flex position="relative" maxW="720px" w="100%" flexDir="column" rowGap={isMobile ? "12px" : "32px"}>
                <Box>
                    <Text mb={isMobile ? "8px" : "16px"} {...FONT("notoSerif", isMobile ? 16 : 32, 400, 1.4)}>
                        {room.room_name}
                    </Text>
                    <Text color="#6b6b6b" {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}>
                        객실설명
                    </Text>
                    <Text color="#6b6b6b" {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}>
                        {room.room_intro}
                    </Text>
                </Box>
                <Box>
                    <Text color="#664628" {...FONT("notoSerif", 14, 400, 1.4)}>
                        Room Type
                    </Text>
                    <Text color="#6b6b6b" {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}>
                        {" "}
                        {room.room_type}
                    </Text>
                </Box>
                <Box>
                    <Text color="#664628" {...FONT("notoSerif", 14, 400, 1.4)}>
                        Number of People
                    </Text>
                    <Flex gap={isMobile ? "8px" : "16px"}>
                        <Text
                            color="#6b6b6b"
                            {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}
                        >{`기준 ${room.people.min}인 ~ 최대 ${room.people.max}인`}</Text>
                    </Flex>
                </Box>
                {/* <Box>
                    <Text color="#664628" {...FONT("notoSerif", 14, 400, 1.4)}>
                        Room Info
                    </Text>
                    <Text color="#6b6b6b" {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}>
                        CheckIn 시간 CheckOut 시간
                    </Text>
                </Box> */}
                <Box>
                    <Text color="#664628" {...FONT("notoSerif", 14, 400, 1.4)}>
                        Size
                    </Text>
                    <Text color="#6b6b6b" {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}>
                        {`${room.room_size}㎡`}
                    </Text>
                </Box>
                <Box>
                    <Text color="#664628" {...FONT("notoSerif", 14, 400, 1.4)}>
                        Facilities
                    </Text>
                    <Flex mt="8px">
                        {activeAmenities.map(({ name, url }) => (
                            <Box
                                key={name}
                                w="48px"
                                h="48px"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                borderRadius="md"
                                bg="rgba(255,255,255,0.1)"
                            >
                                <Image src={url} alt={name} w="100%" h="100%" objectFit="contain" />
                            </Box>
                        ))}
                    </Flex>
                    <Text mt="8px" color="#6b6b6b" {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}>
                        {room.amenity}
                    </Text>
                </Box>
            </Flex>
            <Center>
                <Button
                    h="40px"
                    p="0 24px"
                    background="none"
                    border="1px solid #6b6b6b"
                    borderRadius="20px"
                    color="#6b6b6b"
                    {...FONT("notoSerif", 14, 400, 1.4)}
                    onClick={() => onLink(bookingURL)}
                >
                    Reservation
                </Button>
            </Center>
        </Flex>
    );
};
